var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools"},[_c('nav',{staticClass:"ito-tabs"},[_vm._l((_vm.tabs),function(tab){return [(tab.visible)?_c('router-link',{class:{ active: tab.active },attrs:{"to":tab.target},nativeOn:{"click":function($event){return _vm.getSoundClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t(tab.label)))]):_vm._e()]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }